"use client"

import { useEffect, useState } from "react"
import { useCmdkContext } from "../context"

/**
 * Subscribe to the live (raw) text typed into the command palette input.
 * Lets item registrars outside the `<Cmdk/>` component react to the query —
 * e.g. to run server-side search-as-you-type — without lifting the input state
 * into every consumer.
 */
export function useCmdkQuery(): string {
  const ctx = useCmdkContext()
  const [query, setQuery] = useState(ctx.queryRef.current)

  useEffect(
    () =>
      ctx.onQueryUpdated(() => {
        setQuery(ctx.queryRef.current)
      }),
    [ctx],
  )

  return query
}
